import { useParams } from "react-router-dom";
import { isTaskUpdateMarketInfo } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { UpdateMarketInfoPage } from "./UpdateMarketInfoPage";

const UpdateMarketInfo = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskUpdateMarketInfo(currentTask) || !currentPoint) {
        return <NotFound />;
    }

    return <UpdateMarketInfoPage task={currentTask} point={currentPoint} />;
};

export default UpdateMarketInfo;
